import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { dropdownSpacingMultiplier } from '../../util/ProductModalHelpers';
import { ProductModalContext } from '../../../ProductModalContext';
import SizeSelectorItem from './SizeSelectorItem.jsx';
import { SizeSelectorOptionClicked } from '../../../../../../../utils/Analytics';
import './SizeSelector.css';
import { storeId } from '../../../../../../../../../variables/DevVariables.js';
import { popupStoreId } from '../../../../../../../utils/StoreConfigManager';

const SizeSelector = ({ groupProducts, sku, fontStyle, variantSize, setVariantSize, colors, groupSizes, defaultSize, title, siblings, groupSizesValue }) => {
    const { variantColor, setVariantColor, setSelectedVariantSKU, selectedVariantSKU, productVariantMap, baseSKU, productSKU, productInfo } = useContext(ProductModalContext)
    const [selectorOpen, setSelectorOpen] = useState(false);
    const [sizes, setSizes] = useState(null);

    useEffect(() => {
        setVariantColor(defaultSize);
        setSizes(groupSizes);
        if(storeId !== popupStoreId) {
            setSelectedVariantSKU(productInfo.variants.features_map[defaultSize]);
        }
        if (groupSizes.length <= 1) {
            const oneSize = groupSizes[0];
            setVariantSize(oneSize);
            if(storeId !== popupStoreId) {
                setSelectedVariantSKU(productInfo.variants.features_map[oneSize]);
            }
        }
        return () => { setSelectedVariantSKU(baseSKU) };
    }, [])

    const toggleSelector = () => setSelectorOpen(!selectorOpen);

    const handleOnClick = (size) => {
        setVariantSize(size);
        SizeSelectorOptionClicked(title, baseSKU, size)
        setSelectedVariantSKU(productInfo.variants.features_map[size]);
        toggleSelector();
    };


    const selectorListOffset = () => {
        const numberOfItems = sizes && sizes.length;
        const multiplier = dropdownSpacingMultiplier(numberOfItems);
        const height = numberOfItems * multiplier;
        return `${height}em`;
    }

    const checkStock = (size) => {
        var instock = productInfo.variants?.siblings[productInfo.variants?.features_map[size]]?.available;
        return instock;
    }

    return (
        groupSizes.length > 1 &&
        <div id="size-selector-column" className="flex-center" style={{ ...fontStyle, height: selectorListOffset(), marginTop: '0',zIndex: selectorOpen ? '100' : '50' }}>
            <SizeSelectorItem text={variantSize ? variantSize : 'Size'} sku={sku} onClick={toggleSelector} showArrow={true} arrowDown={selectorOpen} style={variantSize && colors ? { backgroundColor: colors.addToCartPrimaryColor } : null} />

            <div id="size-selector-items" className="flex-center">
                {selectorOpen && sizes && sizes.map((size, index) => (
                    <SizeSelectorItem
                        key={index}
                        relative={true}
                        onClick={() => handleOnClick(size)}
                        text={size}
                        checkStock = {storeId == popupStoreId ? checkStock(size) : true}
                    />
                ))}
            </div>
        </div>
    );
}

SizeSelector.propTypes = {
    groupProducts: PropTypes.array.isRequired,
    fontStyle: PropTypes.object,
    size: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired,
    fetchProductInfo: PropTypes.func.isRequired
};

export default SizeSelector;
